'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.load = load;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'ms/asset-settings/load';

var initialState = {
  settings: {},
  rules: {}
};

// Reducer

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        settings: action.payload.settings,
        rules: action.payload.rules
      });

    default:
      return state;
  }
}

// Action creators

function load(type) {
  return {
    type: LOAD,
    payload: {}
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/assetSettings.js
// module id = 2166
// module chunks = 0